import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';

import OptimumProduct from './OptimumProduct';

export const Wrapper = styled.div`
  background-color: ${({ backgroundColor }) =>
    backgroundColor
      ? themeGet(`colors.${backgroundColor}`)
      : themeGet(`colors.white`)};
  overflow: hidden;
`;

export const StyledContainer = styled(Container)`
  padding: 2.5rem 0;
  width: 100%;

  &.small-padding {
    padding: 2.5rem 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.4')});
    padding: 2rem 0;

    &.small-padding {
      padding: 2rem 0;
      width: calc(100% - ${themeGet('media.grid-gutter.4')});
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    &.small-padding {
      width: calc(100% - ${themeGet('media.grid-gutter.5')});
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    padding: 90px 0 150px;

    &.small-padding {
      padding: 20px 0;
    }
  }

  > h2,
  > h3,
  b,
  strong {
    font-weight: ${themeGet('fontWeights.medium')};
  }

  > h2,
  > h3,
  p {
    text-align: center;
    margin: auto;
  }
`;

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 3rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: grid;
    grid-auto-columns: 1fr;
    grid-template-rows: repeat(10, min-content);
    margin: 3rem auto 0;
    column-gap: 1.5rem;
    max-width: 1024px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    column-gap: 2.5rem;
  }
`;

export const Block = styled(OptimumProduct)`
  margin-bottom: 1.5rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 0;
  }
`;
